module.exports = __webpack_public_path__ + "img/logo.a50ae3df.png";